module.exports = __webpack_public_path__ + "img/ms-sissi-logo.2656f52b.png";